export default "__VITE_ASSET__DWJuP0en__"